
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import Consents from "./components/consents.vue";
import ConsentsEvolution from "./components/consents-evolution.vue";
import LastConsents from "./components/last-consents.vue";
import RelatedTeam from "./components/related-team.vue";
import RecentsActivities from "@/widgets/recents-activities.vue";
import { Consents as SiteConsents } from "@/core/services/consensu/accounts";

export default defineComponent({
  name: "site-details",

  props: {
    account: { type: Object, required: true },
  },

  components: {
    Consents,
    ConsentsEvolution,
    LastConsents,
    RelatedTeam,
    RecentsActivities,
  },

  setup() {
    const route = useRoute();

    let consents = ref();

    onMounted(async () => {
      setCurrentPageTitle("Detalhes");

      let id: any = route.params.id;

      let consentsStats = await SiteConsents(id);
      consents.value = consentsStats.data ? consentsStats.data.docs : [];
    });

    return {
      consents,
    };
  },

  data() {
    return {
      activities: [
        {
          hour: "08:42",
          message: "Novo site Allin.com.br",
          text: "gray-800",
          style: "bolder",
          color: "success",
        },
        {
          hour: "10:00",
          message: "Novo membros",
          text: "gray-800",
          style: "bolder",
          color: "primary",
        },
        {
          hour: "14:37",
          message: "Nova versão de cookies para Kabum está em produção",
          text: "gray-800",
          style: "bolder",
          color: "danger",
        },
        {
          hour: "16:50",
          message: "Relatório exportado com sucesso",
          text: "muted",
          style: "normal",
          color: "primary",
        },
        {
          hour: "21:03",
          message: "Novo site Globo.com",
          text: "gray-800",
          style: "bolder",
          color: "success",
        },
        {
          hour: "23:07",
          message: "Novo site Kabum.com",
          text: "gray-800",
          style: "bolder",
          color: "success",
        },
      ],
      team: [
        {
          id: "b4b0491f-4b41-4e9d-85fc-00fd067f5e88",
          avatar: "",
          name: "Karina Clark",
          permission: "Acesso total",
        },
        {
          id: "667f7162-f46f-4e8b-b753-7fca2ce5460a",
          avatar: "",
          name: "Rober Doe",
          permission: "Acesso limitado",
        },
        {
          id: "f2364781-bce8-4ee1-ad55-599c8177b3dc",
          avatar: "",
          name: "Neil Owen",
          permission: "Acesso total",
        },
        {
          id: "9976fd44-d707-42d1-8d74-44112afdae6b",
          avatar: "",
          name: "Olivia Wild",
          permission: "Acesso total",
        },
        {
          id: "5752985e-bcfb-41c8-aa52-4bf8a55bf708",
          avatar: "",
          name: "Sean Bean",
          permission: "Acesso limitado",
        },
      ],
    };
  },
});
